import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _noop from 'lodash/noop';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts';

// "body &" fixes an issue where basesite overrides color in the "a" tag
const A = styled(Link)`
    margin-right: 5px;
    font-size: 15px;
    font-family: ${FONTS.primaryFont};
    font-weight: 600;
    body & {
        color: ${COLORS.mlbWhite};
        &:hover {
            color: ${COLORS.mlbWhite};
        }
    }
`;

const GameMatchup = ({
    mediaPlayback,
    searchRoute,
    onClick,
}) => {

    const away = mediaPlayback?.playInfo?.teams?.away?.shortName;
    const home = mediaPlayback?.playInfo?.teams?.home?.shortName;
    const gamePk = mediaPlayback?.playInfo?.gamePk;

    if (!away && !home && !gamePk) {

        return null;

    }

    return (
        <A
            to={{
                pathname: searchRoute,
                search: `?q=${encodeURIComponent(`ContentTags = ["gamepk-${gamePk}"] Order by Timestamp DESC`)}`,
            }}
            onClick={onClick}
        >
            {`${away} @ ${home}`}
        </A>
    );

};

GameMatchup.propTypes = {
    mediaPlayback: PropTypes.object,
    searchRoute: PropTypes.string,
    onClick: PropTypes.func,
};

GameMatchup.defaultProps = {
    mediaPlayback: {},
    searchRoute: '/search',
    onClick: _noop,
};

export default GameMatchup;
